<div class="page-content scroll-fix">
    <div class="login-form">

        <div class="login-wrapper">
            <div class="login-body">

                <div class="row no-gutters align-items-center mb-5">
                    <div class="col-size">
                        <app-logo [size]="'30px'"></app-logo>
                    </div>

                    <div class="col">
                        <app-logo-project [size]="'30px'" class="ml-4"></app-logo-project>
                    </div>

                    <div class="col-size">
                        <div class="app-subname">{{ 'LOGIN.APP_SUBNAME' | translate }}</div>
                    </div>
                </div>


                <!--            this is wrong type of alert-->
                <div *ngIf="false"
                     class="alert alert-warning alert-dismissible fade show"
                     role="alert">
                    <button aria-label="Close" class="close" data-dismiss="alert" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="panel-log-in">
                    <form>
                        <div class="row">
                            <div class="col-12">
                                <app-input [(ngModel)]="request.username"
                                           [label]="'LOGIN.USERNAME' | translate"
                                           [uppercase]="false"
                                           autocomplete="on"
                                           name="username"
                                           suffixIconClass="icon-login"></app-input>

                            </div>

                            <div class="col-12 mt-2">
                                <app-input [(ngModel)]="request.password"
                                           [label]="'LOGIN.PASSWORD' | translate"
                                           [uppercase]="false"
                                           autocomplete="on" name="password"
                                           suffixIconClass="icon-password"
                                           type="password"></app-input>
                            </div>

                            <div class="col-12 mt-1 mb-1" style="min-height: 18px;">
                                <app-alert *ngIf="hasError" alertType="danger">
                                    {{ 'LOGIN.INVALID_CREDENTIALS' | translate }}
                                </app-alert>
                            </div>

                            <div class="col-12 mt-2">
                                <button (click)="login()" class="btn btn-block btn-primary" type="submit">
                                    {{ 'LOGIN.BUTTON.LOGIN' | translate }}
                                </button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
            <div class="login-information">
                <div class="row">
                    <div class="col-size">
                        <i class="icon-info-filled"></i>
                    </div>
                    <div class="col">
                        {{ 'LOGIN.INFORMATION' | translate }}
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
